import React, { useCallback } from "react";
import {
  AHIcon,
  AHText,
  Box,
  ListItem,
  RoutineOccasionStatusCircleRelay,
} from "arkh";
import { graphql, useFragment } from "react-relay";
import { WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion$key } from "./__generated__/WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion.graphql";
import { WorkspaceRoutineOccasionItemContainer } from "./WorkspaceRoutineOccasionItemContainer";
import { IssueBadge } from "../WorkspaceComplianceRoutines/IssueBadge";
import { OrgTableTitle } from "../../OrgTable/OrgTable";

export function WorkspaceRoutineOccasionStoresListItem(props: {
  occasion: WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion$key;
  isLast: boolean;
  onPress(
    storeId: string,
    storeName: string,
    storeTimezone: string,
    sequenceNumber: number
  ): void;
}) {
  const data = useFragment(
    graphql`
      fragment WorkspaceRoutineOccasionStoresListItem_routineWorkspaceOccasion on RoutineWorkspaceOccasionEdge {
        store {
          id
          name
          timezone
        }
        occasion {
          ...RoutineOccasionStatusCircle_RoutineOccasion
          registeredIssueCount
          sequenceNumber
          issueCount
        }
      }
    `,
    props.occasion
  );

  const onPress = useCallback(() => {
    props.onPress(
      data.store.id,
      data.store.name,
      data.store.timezone,
      data.occasion.sequenceNumber
    );
  }, [
    props,
    data.store.id,
    data.store.name,
    data.store.timezone,
    data.occasion.sequenceNumber,
  ]);

  return (
    <ListItem
      border="border-primary"
      isLast={props.isLast}
      onPress={onPress}
      displayMode="TABLE"
    >
      <WorkspaceRoutineOccasionItemContainer
        storeName={
          <Box style={{ flexDirection: "row", alignItems: "center" }}>
            <AHIcon type="store" spaceRight="small" color="text-washed" />
            <OrgTableTitle>{data.store.name}</OrgTableTitle>
          </Box>
        }
        activeIssues={
          <Box style={{ flexDirection: "row", alignItems: "center" }}>
            <IssueBadge count={data.occasion.issueCount} size="smallMedium" />
          </Box>
        }
        createdIssues={
          data.occasion.registeredIssueCount ? (
            <AHText>{data.occasion.registeredIssueCount}</AHText>
          ) : null
        }
        status={<RoutineOccasionStatusCircleRelay occasion={data.occasion} />}
      />
    </ListItem>
  );
}
